<template>
  <div class="">
    <Card class="">
      <template #title> Yeni Diyet Tanım </template>
      <template #content>

        <div class=" grid">
          <div class="col-12">
            <Panel class="pb-5">

              <div class=" grid">
                <div class="col-5">
                  <div class="formgrid grid">
                    <div class="field col col-12">
                      <label for="DiyetAd" class="font-bold block">Diyet Adı</label>
                      <InputText id="DiyetAd" type="text" v-model="DiyetAd" class="text-base text-color w-full"
                        :invalid="this.Valid.DiyetAd" />
                    </div>
                    <div class="field col col-12 flex-auto">
                      <label for="Gun" class="font-bold block">Gün</label>
                      <InputNumber v-model="Gun" showButtons buttonLayout="horizontal" :step="1" :min="0" :max="999"
                        :invalid="this.Valid.Gun" fluid class="text-base text-color w-full">
                        <template #incrementbuttonicon>
                          <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                          <span class="pi pi-minus" />
                        </template>
                      </InputNumber>
                    </div>
                  </div>

                </div>
                <div class="col-7">
                  <label for="Gun" class="font-bold block mb-2">Detaylar</label>
                  <Editor v-model="Aciklama" style="height:30vh; width:100%" />
                </div>
              </div>
            </Panel>
          </div>

          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-12 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
export default {
  data() {
    return {
      IslemYapiliyor: false,
      //--------------
      DiyetAd: "",
      Gun: "",
      Aciklama: "",

      // Validation Elements
      Valid: {
        DiyetAd: false,
        Gun: false,
        Aciklama: false,
      },

    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.pTarif = getdata_child.data.Tarif_rowid;
      this.pOgun = getdata_child.data.Ogun_rowid;

      let data = {
        pMusteri: this.pMusteri,
        pDiyetTanim: this.pDiyetTanim,
        pOgun: getdata_child.data.Ogun_rowid,
        pTarif: getdata_child.data.Tarif_rowid
      };
      GlobalServis.GlobalServis("POST", "GetDiyetOgunDetayInfo", data).then((res) => {
        if (res.status == 200) {
          this.DiyetOgunDetay = res.data;
          this.DiyetModal = true;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;


      let data = {
        DiyetAd: this.DiyetAd,
        Gun: this.Gun,
        Aciklama: this.Aciklama,
      };

      GlobalServis.GlobalServis("POST", "SetDiyetTanim", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Diyet oluşturulmuştur",
            life: 3000,
          });
          this._ResetForm();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Diyetisyen/DiyetTanimListesi" });
      });
    },
    _ResetForm() {
      this.DiyetAd = "";
      this.pBirim = 0;
      this.Gun = "";
      this.Aciklama = "";
    },
    _FormCheck() {
      let Check = false;
      if (this.DiyetAd === "") {
        this.Valid.DiyetAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Diyet adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.DiyetAd = false; Check = false; }

      if (this.Gun === "") {
        this.Valid.Gun = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Gun girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Gun = false; Check = false; }

      if (this.Aciklama === "") {
        this.Valid.Aciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Diyet girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Aciklama = false; Check = false; }


      return Check;
    },


  },
  mounted() {

  },
  components: {

  },
};
</script>